<template>
  <div>
    <div class="swiper">
      <el-carousel :interval="5000" height="600px" arrow="always">
        <el-carousel-item v-for="item in homeBanner2" :key="item.banner_id">
          <div
            :style="{
              backgroundImage: 'url(' + item.banner_image + ')',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              height: '600px',
            }"
          ></div>
        </el-carousel-item>
      </el-carousel>
      <Weather></Weather>
    </div>
    <div class="background">
      <div class="wrapper">
        <div class="news-list">
          <div class="news-list-item">
            <div class="image">
              <div class="title">
                <router-link to="/dynamic/notice">
                  {{ getTitle('header.notice') }}
                </router-link>
              </div>
              <img
                :src="noticeList2[0] ? noticeList2[0].news_image : ''"
                @click="goNewsInfo(noticeList2[0].news_id)"
              />
            </div>
            <div class="text">
              <ul>
                <li
                  v-for="item in noticeList2.slice(0, 3)"
                  :key="item.news_id"
                  @click="goNewsInfo(item.news_id)"
                >
                  <span>{{ item.created_at.substring(0, 10) }}</span>
                  {{ item.news_title }}
                </li>
              </ul>
            </div>
          </div>
          <div class="news-list-item">
            <div class="image">
              <div class="title">
                <router-link to="/dynamic/recent-dynamic">
                  {{ getTitle('header.recentDynamic') }}
                </router-link>
              </div>
              <img
                :src="dynamicList2[0] ? dynamicList2[0].news_image : ''"
                @click="goNewsInfo(dynamicList2[0].news_id)"
              />
            </div>
            <div class="text">
              <ul>
                <li
                  v-for="item in dynamicList2.slice(0, 3)"
                  :key="item.news_id"
                  @click="goNewsInfo(item.news_id)"
                >
                  <span>{{ item.created_at.substring(0, 10) }}</span>
                  {{ item.news_title }}
                </li>
              </ul>
            </div>
          </div>
          <div class="news-list-item">
            <div class="image">
              <div class="title">
                <router-link to="/dynamic/news">
                  {{ getTitle('header.news') }}
                </router-link>
              </div>
              <img
                :src="newsList2[0] ? newsList2[0].news_image : ''"
                @click="goNewsInfo(newsList2[0].news_id)"
              />
            </div>
            <div class="text">
              <ul>
                <li
                  v-for="item in newsList2.slice(0, 3)"
                  :key="item.news_id"
                  @click="goNewsInfo(item.news_id)"
                >
                  <span>{{ item.created_at.substring(0, 10) }}</span>
                  {{ item.news_title }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section home-video">
          <video
            controls
            ref="video"
            class="video"
            :poster="contentList01[0] ? contentList01[0].image : ''"
            :src="contentList01[0] ? contentList01[0].video : ''"
          >
            <source
              :src="contentList01[0] ? contentList01[0].video : ''"
              type="video/mp4"
            />
            抱歉，您的浏览器不支持内嵌视频。
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import overview from '@/api/overview';
import Weather from '@/components/Weather/Weather.vue';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
// import overview from '@/store/modules/overview';
export default {
  components: { Weather },
  data() {
    return {
      homeBanner: [],
      noticeList: [],
      dynamicList: [],
      newsList: [],
      contentList: [],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    homeBanner2() {
      return this.localeHomeBanner(this.locale);
    },
    noticeList2() {
      return this.localeNoticeList(this.locale);
    },
    dynamicList2() {
      return this.localeDynamicList(this.locale);
    },
    newsList2() {
      return this.localeNewsList(this.locale);
    },
    contentList01() {
      return this.localeContentList01(this.locale);
    },
  },
  async created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    await this.getHomeBanner();
    //await this.getNoticeList();
    //await this.getDynamicList();
    await this.getNewsList();
    await this.getContentList();
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },

    async getHomeBanner() {
      const homeBannerInfo = await www.getHomeBanner({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
      });
      let homeBannerGet = homeBannerInfo.data;
      homeBannerGet.forEach((item) => {
        if (item.banner_status == 'publish') {
          this.homeBanner.push(item);
        }
      });
    },
    localeHomeBanner(locale) {
      return _.filter(this.homeBanner, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },

    async getNoticeList() {
      const getNoticeList = await www.getNewsList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        category: '1',
      });
      this.noticeList = getNoticeList.data;
    },
    localeNoticeList(locale) {
      return _.filter(this.noticeList, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },

    async getDynamicList() {
      const getDynamicList = await www.getNewsList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        category: '2',
      });
      this.dynamicList = getDynamicList.data;
    },
    localeDynamicList(locale) {
      return _.filter(this.dynamicList, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },

    async getNewsList() {
      const getNewsList = await www.getNewsList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        page_size: '9999',
        //category: '3',
      });

      let data = getNewsList.data;
      if (data && data.length > 0) {
        data.forEach((newItem) => {
          if (newItem.category == '3') {
            this.newsList.push(newItem);
          } else if (newItem.category == '1') {
            this.noticeList.push(newItem);
          } else if (newItem.category == '2') {
            this.dynamicList.push(newItem);
          }
        });
      }
      //this.newsList = getNewsList.data;
    },
    localeNewsList(locale) {
      return _.filter(this.newsList, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },

    async getContentList() {
      const getContentList = await www.getContentList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        category: '10',
        status: 'publish',
        page_size: '100',
      });
      this.contentList = getContentList.data;
    },
    localeContentList01(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('homepage.video.title')
        );
      });
    },
    goNewsInfo(ID) {
      routerTo.toNewsInfo(this.$router, false, { ID: ID });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.background {
  padding-top: 40px;
  background: #fff url(../assets/images/bg-home.png) repeat-y center top;
  background-size: contain;
}
.swiper {
  height: 600px;
  position: relative;
}
.wrapper {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
}
.section {
  margin-bottom: 40px;
  .title {
    margin-bottom: 20px;
    padding: 20px 0;
    text-align: center;
    h2 {
      margin-bottom: 14px;
      color: #191b26;
      font-weight: normal;
      font-size: 30px;
      line-height: 42px;
    }
    p {
      margin-bottom: 20px;
    }
    p:last-child {
      margin-bottom: 0;
    }
    .more {
      display: inline-block;
      padding: 8px 36px;
      border-radius: 18px;
      color: #fff;
      background: #31a775;
      cursor: pointer;
    }
  }
}
.news-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  .news-list-item {
    width: 356px;
    background: #fff;
    .image {
      position: relative;
      img {
        width: 356px;
        height: 220px;
        cursor: pointer;
      }
      .title {
        padding: 10px 15px;
        position: absolute;
        top: 10px;
        left: 0;
        border-radius: 0 100px 100px 0;
        color: #fff;
        font-size: 16px;
        background-image: linear-gradient(90deg, #39a7dc 0%, #1fc37d 100%);
        a {
          color: #fff;
        }
      }
    }
    .text {
      ul {
        height: 122px;
        padding: 8px 12px;
        border: 1px solid #dbe6e1;
        li {
          border-bottom: 1px solid #eee;
          overflow: hidden;
          color: #191b26;
          line-height: 34px;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: keep-all;
          cursor: pointer;
          span {
            float: right;
            color: #9e9e9e;
          }
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
.home-video {
  margin-bottom: 80px;
  .video {
    width: 1100px;
    outline: none;
    cursor: pointer;
  }
}
.row-reverse {
  flex-direction: row-reverse;
}
</style>
